import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "base-table" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: "empty",
  class: "base-table__empty-row"
}
const _hoisted_4 = ["colspan"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode("No entries to show")
const _hoisted_6 = ["colspan"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Loading...")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (column, colIndex) => {
            return (_openBlock(), _createElementBlock("th", {
              key: colIndex,
              style: _normalizeStyle(_ctx.getColumnStyle(column))
            }, _toDisplayString(column.label), 5))
          }), 128)),
          (_ctx.hasRowOptions)
            ? (_openBlock(), _createElementBlock("th", _hoisted_2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.isEmpty)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
              _createElementVNode("td", {
                class: "base-table__empty",
                colspan: _ctx.columnsCount
              }, [
                _renderSlot(_ctx.$slots, "empty", {}, () => [
                  _hoisted_5
                ])
              ], 8, _hoisted_4)
            ]))
          : (_ctx.isLoading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.loadingDummiesCount, (i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: i,
                  class: "base-table__loading-row"
                }, [
                  _createElementVNode("td", {
                    class: "base-table__loading",
                    colspan: _ctx.columnsCount
                  }, [
                    _renderSlot(_ctx.$slots, "loading", {}, () => [
                      _hoisted_7
                    ])
                  ], 8, _hoisted_6)
                ]))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.data, (row, rowIndex) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: rowIndex,
                  class: _normalizeClass(_ctx.getRowClass(rowIndex, row))
                }, [
                  _renderSlot(_ctx.$slots, "row", _normalizeProps(_guardReactiveProps({ row })), () => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleColumns, (column, colIndex) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: colIndex,
                        class: _normalizeClass([
								{
									'base-table__td--primary': !!column.primary,
								},
								..._ctx.getColumnClass(column.class),
							])
                      }, [
                        _renderSlot(_ctx.$slots, `col-${column.field}`, _normalizeProps(_guardReactiveProps({ row, item: row[column.field] })), () => [
                          _createTextVNode(_toDisplayString(row[column.field]), 1)
                        ])
                      ], 2))
                    }), 128))
                  ]),
                  (_ctx.hasRowOptions)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                        _renderSlot(_ctx.$slots, "row-options", _normalizeProps(_guardReactiveProps({ row })))
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
      ]),
      (_ctx.hasFooter)
        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_9, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", { colspan: _ctx.columnsCount }, [
                _renderSlot(_ctx.$slots, "footer")
              ], 8, _hoisted_10)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}